import * as Styles from './global-vessel-filter.styled.ts'
import {type JSX} from 'react'
import {VesselSelectorButton} from '../vessel-selector/vessel-selector-button.tsx'
import {useGlobalVesselFilterContext} from './global-vessel-filter-context.ts'
import {useLocation} from 'react-router'

// NOTE: Temporary before enabling on all the other pages with the legacy filter
const ENABLED_PATHS = ['/new-vessels']

interface GlobalVesselFilterProps {
    variant: 'hamburger' | 'desktop'
}

export function GlobalVesselFilter(props: GlobalVesselFilterProps): JSX.Element | null {
    const {variant} = props
    const {pathname} = useLocation()
    const {isLoading, allVesselArray, selectedVesselIds, onChange, setIsOpen} =
        useGlobalVesselFilterContext()

    if (!ENABLED_PATHS.includes(pathname)) {
        return null
    }

    const VesselFilter = (
        <Styles.VesselFilterButton>
            <VesselSelectorButton
                vesselsWithTags={allVesselArray}
                selectedVesselIds={selectedVesselIds ?? new Set()}
                onChange={onChange}
                onOpenChange={setIsOpen}
                granularMode={false}
                isLoading={isLoading}
                theme="dark"
            />
        </Styles.VesselFilterButton>
    )
    return variant === 'desktop' ? (
        <Styles.FilterBar id="global-vessel-filter">
            <Styles.Content>{VesselFilter}</Styles.Content>
        </Styles.FilterBar>
    ) : (
        <Styles.NavBar>{VesselFilter}</Styles.NavBar>
    )
}
